import { Box, Grid, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';

const AtrasosNaProducao = ({ data }) => {
  const total =
    (data?.atrasadas || 0) +
    (data?.vencehoje || 0) +
    (data?.proximasvenc || 0) +
    (data?.noprazo || 0);

  const getPercent = (value) => {
    if (!total) return '0%';
    return `${((value / total) * 100).toFixed(1)}%`;
  };

  const pieData = [
    {
      id: 0,
      label: `Atrasadas (${getPercent(data?.atrasadas || 0)})`,
      value: data?.atrasadas || 0,
      color: '#d32f2f',
    },
    {
      id: 1,
      label: `Vence Hoje (${getPercent(data?.vencehoje || 0)})`,
      value: data?.vencehoje || 0,
      color: '#ed6c02',
    },
    {
      id: 2,
      label: `Vence em até 3 dias (${getPercent(data?.proximasvenc || 0)})`,
      value: data?.proximasvenc || 0,
      color: '#f9a825',
    },
    {
      id: 3,
      label: `No Prazo (${getPercent(data?.noprazo || 0)})`,
      value: data?.noprazo || 0,
      color: '#2e7d32',
    },
  ];
  if (data) {
    return (
      <Grid item xs={12} md={6}>
        <Box gap={2} height="100%" display="flex" flexDirection="column">
          <Typography variant="h5" fontWeight="bold">
            Atrasos na Produção
          </Typography>
          <Box mt="auto" width="100%">
            <PieChart
              height={300}
              series={[
                {
                  data: pieData,
                  innerRadius: 70,
                  outerRadius: 120,
                  paddingAngle: 2,
                  cornerRadius: 5,
                },
              ]}
              slotProps={{
                legend: {
                  direction: 'column',
                  position: {
                    vertical: 'middle',
                    horizontal: 'right',
                  },
                },
              }}
            />
          </Box>
        </Box>
      </Grid>
    );
  }

  return null;
};

export default AtrasosNaProducao;
